import React, { createContext, useContext, ReactNode } from 'react';

interface RTLContextType {
  direction: 'rtl' | 'ltr';
  isRTL: boolean;
}

const RTLContext = createContext<RTLContextType | undefined>(undefined);

interface RTLProviderProps {
  children: ReactNode;
}

export const RTLProvider: React.FC<RTLProviderProps> = ({ children }) => {
  const direction = 'rtl';
  const isRTL = direction === 'rtl';

  return (
    <RTLContext.Provider value={{ direction, isRTL }}>
      {children}
    </RTLContext.Provider>
  );
};

export const useRTL = (): RTLContextType => {
  const context = useContext(RTLContext);
  if (!context) {
    throw new Error('useRTL must be used within RTLProvider');
  }
  return context;
};
